export default function Contact() {
  return (
    <div className="bg-[var(--t-bg)] min-h-screen text-[var(--t-text)] pt-32 pb-20 overflow-visible">
      <div className="max-w-4xl mx-auto px-6 overflow-visible w-full">
        <div className="text-center mb-16 overflow-visible w-full">
          <h1 
            className="text-4xl md:text-5xl font-black mb-6 italic tracking-tighter uppercase px-4 text-center"
            style={{ overflow: 'visible', whiteSpace: 'nowrap' }}
          >
            Contact <span className="inline-block pr-6 text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">Us</span>
          </h1>
          <p className="text-xl text-[var(--t-text-muted)] max-w-2xl mx-auto font-medium">
            We're here to help you scale your real estate empire with mission-critical infrastructure.
          </p>
        </div>

        <div className="max-w-2xl mx-auto p-10 rounded-[2rem] bg-[var(--t-surface)] border border-[var(--t-border)] shadow-2xl">
          <form className="space-y-8" onSubmit={(e) => e.preventDefault()}>
            <div className="space-y-3">
              <label className="text-[10px] font-black text-[var(--t-text-muted)] uppercase tracking-[0.2em] ml-1">Identity</label>
              <input 
                type="text" 
                placeholder="FULL NAME"
                className="w-full px-6 py-5 rounded-2xl bg-[var(--t-bg)] border border-[var(--t-border)] text-white font-bold placeholder:text-white/10 focus:border-indigo-500/50 focus:ring-4 focus:ring-indigo-500/10 outline-none transition-all uppercase tracking-widest text-xs"
              />
            </div>
            <div className="space-y-3">
              <label className="text-[10px] font-black text-[var(--t-text-muted)] uppercase tracking-[0.2em] ml-1">Digital Address</label>
              <input 
                type="email" 
                placeholder="EMAIL@EXAMPLE.COM"
                className="w-full px-6 py-5 rounded-2xl bg-[var(--t-bg)] border border-[var(--t-border)] text-white font-bold placeholder:text-white/10 focus:border-indigo-500/50 focus:ring-4 focus:ring-indigo-500/10 outline-none transition-all uppercase tracking-widest text-xs"
              />
            </div>
            <div className="space-y-3">
              <label className="text-[10px] font-black text-[var(--t-text-muted)] uppercase tracking-[0.2em] ml-1">Message Brief</label>
              <textarea 
                rows={4}
                placeholder="HOW CAN WE ASSIST YOUR EMPIRE?"
                className="w-full px-6 py-5 rounded-2xl bg-[var(--t-bg)] border border-[var(--t-border)] text-white font-bold placeholder:text-white/10 focus:border-indigo-500/50 focus:ring-4 focus:ring-indigo-500/10 outline-none transition-all resize-none uppercase tracking-widest text-xs"
              />
            </div>
            <button 
              type="submit"
              className="w-full py-6 rounded-2xl bg-indigo-600 hover:bg-indigo-500 text-white font-black uppercase tracking-[0.2em] transition-all hover:scale-[1.02] shadow-2xl shadow-indigo-600/30 hover-glow"
            >
              Execute Transmission
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
